import { gql } from '@apollo/client';

export const DASHBOARD_FUNDER_PROGRAMMES = gql`
  query DashboardFunderProgrammes($input: FilterArgs) {
    dashboardFunderProgrammes(input: $input) {
      id
      name
      fromDate
      toDate
      districts
      beneficiariesReached
      sessionsCompleted
      interventionTypes
      provinces
      schoolsReached
      serviceProviders {
        id
      }
      interventions {
        id
      }
    }
  }
`;
